import { TenantEntity } from '../TenantEntity'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export class ChargeItem extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }

  // 根据scaleCode 获取chargeItem
  static async getChargeItemByScaleCode(code) {
    if (code === null || code === '') { return null }

    const chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'scaleCode', code)
    return chargeItem
  }

  static getChargeItemById(itemId) {
    if (itemId === null || itemId === '') { return null }

    const chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'itemId', itemId)
    return chargeItem
  }
}
